export default __webpack_public_path__ + "static/media/icon-bookmark-filled.9c93acb8.svg";